<template>
  <div>
    <v-card class="quoteSideInfo">
      <v-toolbar color="grey darken-1" dark>
        <v-toolbar-title>
          <v-icon large>{{cargoIcon}}</v-icon>
          Cargo
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn flat slot="activator" @click="doSave()" :loading="quotation.saving">
            Save
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
          <span>Save Quotation/Proposal</span>
        </v-tooltip>
        <v-tooltip top>
          <v-menu bottom left slot="activator">
            <v-btn slot="activator" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="promptNTU = true">
                <v-list-tile-title>Not Taken Up</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="promptVoid = true">
                <v-list-tile-title>Void</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <span>More Options</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs4>
              <v-subheader class="queryLabel">Quotation No.</v-subheader>
            </v-flex>
            <v-flex xs8>
              <span class="title">{{commonForm.proposalNo}}</span>
            </v-flex>
            <template v-if="commonInfo.premium.billPremiumPayable">
              <v-flex xs4>
                <v-subheader class="queryLabel">Premium Payable</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span class="title">{{commonForm.billCurr}} {{formatDisplayNumber(commonInfo.premium.billPremiumPayable)}}</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.siDeclared">
              <v-flex xs4>
                <v-subheader class="queryLabel">Declared Sum Insured</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span class="title">{{siDeclared}}</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.siBalance">
              <v-flex xs4>
                <v-subheader class="queryLabel">Balance Sum Insured</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span class="title">{{siBalance}}</span>
              </v-flex>
            </template>
            <v-flex xs4>
              <v-subheader class="queryLabel">Current Status</v-subheader>
            </v-flex>
            <v-flex xs8>
              <span>{{currentStatusLabel}}</span>
            </v-flex>
            <v-flex xs4>
              <v-subheader class="queryLabel">Intermediary</v-subheader>
            </v-flex>
            <v-flex xs8>
              <span>{{intermediary}}</span>
            </v-flex>
            <template v-if="commonForm.quotationType">
              <v-flex xs4>
                <v-subheader class="queryLabel">Quotation Type</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div>{{quotationType(commonForm.quotationType)}}</div>
              </v-flex>
            </template>
            <template v-if="commonForm.masterProposalNo">
              <v-flex xs4>
                <v-subheader class="queryLabel">Contract/Master Proposal No.</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div>{{commonForm.masterProposalNo}}</div>
              </v-flex>
            </template>
            <template v-if="commonForm.product">
              <v-flex xs4>
                <v-subheader class="queryLabel">Product</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{product}}</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.busCls">
              <v-flex xs4>
                <v-subheader class="queryLabel">Business Class</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{busCls}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.acceptDate">
              <v-flex xs4>
                <v-subheader class="queryLabel">Acceptance Date</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{formatDate(commonForm.acceptDate)}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.campaign">
              <v-flex xs4>
                <v-subheader class="queryLabel">Campaign</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{campaign}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.promotion">
              <v-flex xs4>
                <v-subheader class="queryLabel">Promotion</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{promotion}}</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.comdty">
              <v-flex xs4>
                <v-subheader class="queryLabel">Commodity</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{comdty}}</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.pack">
              <v-flex xs4>
                <v-subheader class="queryLabel">Packing Type</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{pack}}</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.si">
              <v-flex xs4>
                <v-subheader class="queryLabel">Sum Insured</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{si}}</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.siUplift">
              <v-flex xs4>
                <v-subheader class="queryLabel">SI Uplift %</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{siUplift}}</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.tolerance">
              <v-flex xs4>
                <v-subheader class="queryLabel">Tolerance on Cr Amt.</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{tolerance}}</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.siCurr">
              <v-flex xs4>
                <v-subheader class="queryLabel">Sum Insured Currency</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{siCurr}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.billCurr">
              <v-flex xs4>
                <v-subheader class="queryLabel">Billing Currency</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{billCurr}}</span>
              </v-flex>
            </template>
            <template v-if="convy">
              <v-flex xs4>
                <v-subheader class="queryLabel">Conveyance</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{convy}}</span>
              </v-flex>
            </template>
            <template v-if="vesNo">
              <v-flex xs4>
                <v-subheader class="queryLabel">Vessel No.</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{vesNo}}</span>
              </v-flex>
            </template>
            <template v-if="voyNo">
              <v-flex xs4>
                <v-subheader class="queryLabel">Voyage No.</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{voyNo}}</span>
              </v-flex>
            </template>
            <template v-if="voyArea">
              <v-flex xs4>
                <v-subheader class="queryLabel">Voyage Area Code</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{voyArea}}</span>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <confirm v-model="promptNTU" @ok="doNTU">
      Confirm that you want to change the status of this Quotation to
      <b>Not Taken Up</b>?
    </confirm>
    <confirm v-model="promptVoid" @ok="doVoid">
      Confirm that you want to change the status of this Quotation to
      <b>Void</b>?
    </confirm>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { extractLabel } from '@/utils/extract'
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { quoteStatus, appIcon } from '@/const/underwriting'
import { quotationType } from '@/const/underwriting/cargo'

export default {
  data() {
    return {
      promptNTU: false,
      promptVoid: false
    }
  },
  computed: {
    quotation() {
      return this.$store.state.agency.quotation
    },
    currentStatusLabel() {
      if (quoteStatus[this.quotation.commonInfo.statusCode]) {
        return quoteStatus[this.quotation.commonInfo.statusCode]
      } else {
        return 'Unknown Status'
      }
    },
    cargoForm() {
      return this.quotation.cargoForm
    },
    commonForm() {
      return this.quotation.commonForm
    },
    commonInfo() {
      return this.quotation.commonInfo
    },
    cargoParam() {
      return this.quotation.cargoParam
    },
    intermediary() {
      return extractLabel(this.$store.state.agency.quotationSettings.intermediaries, this.quotation.commonForm.intermediary)
    },
    product() {
      return extractLabel(this.cargoParam.product, this.commonForm.product)
    },
    busCls() {
      return extractLabel(this.cargoParam.busCls, this.cargoForm.busCls)
    },
    comdty() {
      return extractLabel(this.cargoParam.comdty, this.cargoForm.comdty)
    },
    pack() {
      return extractLabel(this.cargoParam.pack, this.cargoForm.pack)
    },
    si() {
      if (this.cargoForm.siCurr) {
        return this.cargoForm.siCurr + ' ' + formatDisplayNumber(Number(this.cargoForm.si))
      } else {
        return formatDisplayNumber(Number(this.cargoForm.si))
      }
    },
    tolerance() {
      return formatDisplayNumber(this.cargoForm.tolerance) + '%'
    },
    siUplift() {
      return formatDisplayNumber(this.cargoForm.siUplift) + '%'
    },
    siDeclared() {
      if (this.cargoForm.siCurr) {
        return this.cargoForm.siCurr + ' ' + formatDisplayNumber(this.cargoForm.siDeclared)
      } else {
        return formatDisplayNumber(this.cargoForm.siDeclared)
      }
    },
    siBalance() {
      if (this.cargoForm.siCurr) {
        return this.cargoForm.siCurr + ' ' + formatDisplayNumber(this.cargoForm.siBalance)
      } else {
        return formatDisplayNumber(this.cargoForm.siBalance)
      }
    },
    siCurr() {
      return extractLabel(this.cargoParam.currRates, this.cargoForm.siCurr)
    },
    billCurr() {
      return extractLabel(this.cargoParam.currRates, this.commonForm.billCurr)
    },
    convy() {
      return extractLabel(this.cargoParam.convy, this.cargoForm.convy)
    },
    vesNo() {
      return extractLabel(this.cargoParam.vessel.data, this.cargoForm.vesNo)
    },
    voyNo() {
      return extractLabel(this.cargoParam.voyage, this.cargoForm.voyNo)
    },
    voyArea() {
      return extractLabel(this.cargoParam.voyArea, this.cargoForm.voyArea)
    },
    campaign() {
      return extractLabel(this.cargoParam.campaign, this.commonForm.campaign)
    },
    promotion() {
      return extractLabel(this.cargoParam.promotion, this.commonForm.promotion)
    },
    cargoIcon() {
      return appIcon.CARGO
    }
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    quotationType(value) {
      return quotationType[value]
    },
    doSave() {
      // Emit saving event on global event bus
      // Each quote page should listen to this and do partial Submit and save
      this.$root.$emit('saveQuote')
    },
    doNTU() {
      this.$root.$emit('ntu')
    },
    doVoid() {
      this.$root.$emit('void')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">
@media (min-width: 1264px) {
  .quoteSideInfo {
    // Module specific override
    min-height: 425px;
  }
}

.permitStatus {
  padding-left: 20px;
}
</style>
